export default "__VITE_ASSET__DkUBA38c__"